import { AddProductsToWishlistDocument } from '../../queries/AddProductsToWishlist.gql'
import { useMutation } from './useMutation'

const useAddProductsToWishlist = () => {
  const [mutation] = useMutation(AddProductsToWishlistDocument)

  const addProductsToWishlist = (productSku: string) =>
    mutation({
      variables: {
        wishlistId: '0',
        wishlistItems: [
          {
            sku: productSku,
            quantity: 1,
          },
        ],
      },
    })

  return addProductsToWishlist
}

export default useAddProductsToWishlist
